export default __webpack_public_path__ + "static/media/Guardians of the Forest.31f820a9.png";